import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { Skdp as SkdpType } from "@/types/index";
import Skdp from "@/services/new/Skdp";

@Module({ dynamic: true, namespaced: true, store, name: "pasien-skdp" })
class PasienSkdp extends VuexModule {
  upcomingList: SkdpType[] = [];

  @Mutation
  SET_UPCOMING_LIST(data: SkdpType[]) {
    this.upcomingList = data;
  }

  @Action({ rawError: true })
  async getUpcomingList(params: { rm: string; tgl_kontrol_gt: string }) {
    const resp = await Skdp.get(params);

    this.SET_UPCOMING_LIST(resp.data);
  }

  @Action({ rawError: true })
  reset() {
    this.SET_UPCOMING_LIST([]);
  }
}

export default getModule(PasienSkdp);
